export default __webpack_public_path__ + "static/ra-transparent-39553124767db943be582fac9346c512.png";